// Auto-generated from contact.html. Verbatim redesign import. Do NOT edit.
export const STYLES = `

:root{
  --bone:#FAF8F4; --aubergine:#15102A; --aubergine-tier:#1A1531; --aubergine-raised:#221A42;
  --champ:#A88B4A; --champ-light:#E8D9B8; --lava:#FF7A33; --signal-red:#C2281D;
  --font-display:'Source Serif 4',Georgia,serif;
  --font-mono:'JetBrains Mono','SF Mono',monospace;
  --font-body:'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;
  --ease-out:cubic-bezier(0.22,1,0.36,1);
}
*{box-sizing:border-box;margin:0;padding:0}
body{font-family:var(--font-body);background:var(--aubergine);color:var(--bone);-webkit-font-smoothing:antialiased}
.wrap{max-width:1200px;margin:0 auto;padding:0 24px}
@media(min-width:1024px){.wrap{padding:0 32px}}
a{color:inherit}

/* ---------- HERO ---------- */
.c-hero{position:relative;overflow:hidden;background:var(--aubergine);
  background-image:radial-gradient(ellipse 70% 60% at 0% 0%,rgba(168,139,74,0.20),transparent 62%),radial-gradient(ellipse 80% 70% at 100% 100%,rgba(255,122,51,0.14),transparent 66%);
  padding:clamp(96px,14vh,160px) 0 clamp(48px,7vh,72px);text-align:center}
.c-hero .wrap{max-width:860px}
.c-hero h1{font-family:var(--font-display);font-weight:400;letter-spacing:-0.025em;line-height:1.06;font-size:clamp(38px,5.4vw,76px);color:var(--bone);margin:0 auto}
.c-hero h1 em{font-style:italic;color:var(--champ-light)}
.c-hero p{margin:20px auto 0;font-size:clamp(15px,1.7vw,18px);line-height:1.6;color:rgba(250,248,244,0.72);max-width:54ch}

/* ---------- BODY (light theme, single column) ---------- */
.c-body{background:var(--bone);padding:clamp(40px,6vh,72px) 0 clamp(72px,10vh,120px)}
.c-body .wrap{max-width:860px}

/* ---------- FORM CARD (light) ---------- */
.card{background:#FFFFFF;border:1px solid #E7DFD0;border-radius:18px;padding:clamp(24px,3vw,40px);box-shadow:0 1px 2px rgba(21,16,42,0.03),0 16px 40px -32px rgba(21,16,42,0.18)}
.row{display:grid;gap:20px;margin-bottom:20px}
@media(min-width:560px){.row.two{grid-template-columns:1fr 1fr}}
.field label{display:block;font-size:13px;font-weight:600;color:var(--aubergine);margin-bottom:9px}
.field label .req{color:rgba(21,16,42,0.4);font-weight:400}
.field input,.field select,.field textarea{
  width:100%;border:1px solid #DDD4C4;background:#FBF9F5;border-radius:10px;
  padding:13px 15px;font-family:var(--font-body);font-size:14px;color:var(--aubergine);outline:none;
  transition:border-color .25s var(--ease-out),box-shadow .25s var(--ease-out),background .25s}
.field input::placeholder,.field textarea::placeholder{color:rgba(21,16,42,0.32)}
.field input:focus,.field select:focus,.field textarea:focus{border-color:var(--champ);box-shadow:0 0 0 3px rgba(168,139,74,0.12);background:#FFFFFF}
.field textarea{resize:vertical;min-height:140px}
.field select{appearance:none;background-image:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='%23A88B4A' stroke-width='2'><polyline points='6 9 12 15 18 9'/></svg>");background-repeat:no-repeat;background-position:right 15px center;padding-right:42px}
.field select option{background:#FFFFFF;color:var(--aubergine)}

/* champagne submit button (warm gold, on light) */
.btn-submit{width:100%;display:inline-flex;align-items:center;justify-content:center;gap:10px;
  border:0;border-radius:10px;padding:15px 22px;cursor:pointer;
  font-family:var(--font-mono);font-size:12px;letter-spacing:0.05em;color:var(--aubergine);
  background:radial-gradient(ellipse at 30% 30%,#E8D9B8 0%,#C9A24B 55%,#A88B4A 100%);
  box-shadow:inset 0 1px 0 rgba(255,255,255,0.5),0 10px 28px -14px rgba(168,139,74,0.7);
  transition:filter .25s,box-shadow .25s,gap .25s}
.btn-submit:hover{filter:brightness(1.05) saturate(1.04);gap:14px;box-shadow:inset 0 1px 0 rgba(255,255,255,0.55),0 14px 36px -14px rgba(168,139,74,0.85)}
.btn-submit:disabled{opacity:0.6;cursor:default}
.btn-submit svg{width:14px;height:14px}
.spin{animation:spin 0.8s linear infinite}
@keyframes spin{to{transform:rotate(360deg)}}

.err{border:1px solid rgba(194,40,29,0.35);background:rgba(194,40,29,0.07);color:#A31C13;border-radius:10px;padding:11px 15px;font-size:13px;margin-bottom:20px}

/* ---------- WHAT HAPPENS NEXT (light) ---------- */
.next{margin-top:20px;background:#F3EEE3;border:1px solid #E7DFD0;border-radius:14px;padding:22px clamp(20px,2.4vw,28px)}
.next-eyebrow{font-family:var(--font-mono);font-size:10px;font-weight:500;letter-spacing:0.16em;text-transform:uppercase;color:rgba(21,16,42,0.5);margin-bottom:16px}
.next-row{display:flex;flex-direction:column;gap:14px}
@media(min-width:600px){.next-row{flex-direction:row;align-items:center;gap:0}}
.next-step{display:flex;align-items:center;gap:11px}
.next-num{flex:0 0 auto;display:flex;align-items:center;justify-content:center;height:26px;width:26px;border-radius:50%;border:1px solid rgba(168,139,74,0.5);font-family:var(--font-mono);font-size:11px;color:var(--champ)}
.next-step span:last-child{font-size:14px;color:rgba(21,16,42,0.72)}
.next-arrow{margin:0 16px;color:rgba(168,139,74,0.4);flex:0 0 auto}
@media(max-width:599px){.next-arrow{display:none}}

/* ---------- SUCCESS (light) ---------- */
.success{text-align:center;padding:48px 16px}
.success-ring{margin:0 auto 22px;height:52px;width:52px;border-radius:50%;border:1px solid rgba(168,139,74,0.5);background:rgba(168,139,74,0.10);display:flex;align-items:center;justify-content:center;color:var(--champ)}
.success h3{font-family:var(--font-display);font-size:23px;font-weight:500;color:var(--aubergine)}
.success p{margin-top:12px;font-size:14px;color:rgba(21,16,42,0.7)}
.success button{margin-top:24px;display:inline-flex;align-items:center;border:1px solid rgba(168,139,74,0.5);background:transparent;color:var(--aubergine);border-radius:10px;padding:11px 18px;font-family:var(--font-mono);font-size:12px;letter-spacing:0.04em;cursor:pointer;transition:background .25s,border-color .25s}
.success button:hover{background:rgba(168,139,74,0.08);border-color:var(--champ)}
.hidden{display:none}



/* ===== T-REX global chrome (scoped, self-contained) ===== */
.tgn,.tgf{--tgc-aub:#15102A;--tgc-aub2:#1A1531;--tgc-aub3:#221A42;--tgc-bone:#FAF8F4;
  --tgc-champ:#A88B4A;--tgc-champL:#E8D9B8;--tgc-lava:#FF7A33;
  font-family:'Inter',system-ui,-apple-system,Segoe UI,Roboto,sans-serif;box-sizing:border-box;}
.tgn *,.tgf *{box-sizing:border-box;}
.tgn{position:sticky;top:0;z-index:1000;background:rgba(21,16,42,0.90);
  -webkit-backdrop-filter:saturate(140%) blur(14px);backdrop-filter:saturate(140%) blur(14px);
  border-bottom:1px solid rgba(232,217,184,0.12);}
.tgn-bar{max-width:1240px;margin:0 auto;height:60px;padding:0 clamp(18px,4vw,40px);
  display:flex;align-items:center;justify-content:space-between;gap:24px;}
.tgn-brand{display:inline-flex;align-items:center;line-height:0;flex:0 0 auto;}
.tgn-wordmark{height:24px;width:auto;display:block;}
.tgn-links{display:flex;align-items:center;gap:clamp(6px,1.4vw,18px);}
.tgn-item{position:relative;display:flex;align-items:center;height:60px;}
.tgn-link{display:inline-flex;align-items:center;gap:5px;color:rgba(250,248,244,0.74);
  text-decoration:none;font-size:14px;font-weight:500;letter-spacing:.01em;padding:6px 4px;
  transition:color .18s ease;}
.tgn-link:hover,.tgn-item:hover .tgn-link{color:var(--tgc-bone);}
.tgn-link.tgn-active{color:var(--tgc-bone);}
.tgn-caret{font-size:9px;opacity:.7;transition:transform .2s ease;}
.tgn-item:hover .tgn-caret{transform:translateY(1px);}
.tgn-ext{font-size:11px;opacity:.7;}
.tgn-menu{position:absolute;top:58px;left:-14px;min-width:280px;padding:8px;
  background:var(--tgc-aub2);border:1px solid rgba(232,217,184,0.14);border-radius:12px;
  box-shadow:0 24px 60px -20px rgba(0,0,0,0.7);opacity:0;visibility:hidden;transform:translateY(6px);
  transition:opacity .18s ease,transform .18s ease,visibility .18s;}
.tgn-has-menu:hover .tgn-menu{opacity:1;visibility:visible;transform:translateY(0);}
.tgn-menu a{display:flex;flex-direction:column;gap:2px;padding:10px 12px;border-radius:8px;
  text-decoration:none;transition:background .15s ease;}
.tgn-menu a span{color:var(--tgc-bone);font-size:14px;font-weight:600;}
.tgn-menu a small{color:rgba(250,248,244,0.55);font-size:12px;font-weight:400;}
.tgn-menu a:hover{background:var(--tgc-aub3);}
.tgn-actions{display:flex;align-items:center;gap:12px;flex:0 0 auto;}
.tgn-cta{display:inline-flex;align-items:center;text-decoration:none;font-size:13.5px;font-weight:600;
  color:var(--tgc-aub);padding:9px 18px;border-radius:9px;white-space:nowrap;
  background:linear-gradient(180deg,#F4E9CF 0%,var(--tgc-champL) 100%);
  box-shadow:0 1px 0 rgba(255,255,255,0.4) inset,0 6px 18px -8px rgba(232,217,184,0.5);
  transition:transform .16s ease,box-shadow .16s ease;}
.tgn-cta:hover{transform:translateY(-1px);box-shadow:0 10px 24px -10px rgba(232,217,184,0.7);}
.tgn-burger{display:none;flex-direction:column;justify-content:center;gap:4px;width:40px;height:38px;
  background:transparent;border:1px solid rgba(232,217,184,0.22);border-radius:9px;cursor:pointer;padding:0 9px;}
.tgn-burger span{display:block;height:2px;width:100%;background:var(--tgc-bone);border-radius:2px;transition:transform .2s ease,opacity .2s ease;}
.tgn.tgn-open .tgn-burger span:nth-child(1){transform:translateY(6px) rotate(45deg);}
.tgn.tgn-open .tgn-burger span:nth-child(2){opacity:0;}
.tgn.tgn-open .tgn-burger span:nth-child(3){transform:translateY(-6px) rotate(-45deg);}
.tgn-panel{display:none;flex-direction:column;padding:10px clamp(18px,4vw,40px) 22px;
  background:var(--tgc-aub);border-top:1px solid rgba(232,217,184,0.1);gap:2px;}
.tgn.tgn-open .tgn-panel{display:flex;}
.tgn-acc{border-bottom:1px solid rgba(232,217,184,0.08);}
.tgn-acc summary{list-style:none;cursor:pointer;color:var(--tgc-bone);font-size:15px;font-weight:600;
  padding:14px 2px;display:flex;justify-content:space-between;align-items:center;}
.tgn-acc summary::-webkit-details-marker{display:none;}
.tgn-acc summary::after{content:"+";color:var(--tgc-champL);font-size:18px;}
.tgn-acc[open] summary::after{content:"\\2212";}
.tgn-acc a{display:block;color:rgba(250,248,244,0.7);text-decoration:none;font-size:14px;padding:9px 2px 9px 14px;}
.tgn-acc a:hover{color:var(--tgc-bone);}
.tgn-plink{display:block;color:var(--tgc-bone);text-decoration:none;font-size:15px;font-weight:600;
  padding:14px 2px;border-bottom:1px solid rgba(232,217,184,0.08);}
.tgn-pcta{display:block;text-align:center;margin-top:16px;text-decoration:none;font-size:14.5px;font-weight:600;
  color:var(--tgc-aub);padding:13px 18px;border-radius:10px;
  background:linear-gradient(180deg,#F4E9CF 0%,var(--tgc-champL) 100%);}
@media(max-width:900px){
  .tgn-links{display:none;}
  .tgn-burger{display:flex;}
  .tgn-cta{display:none;}
}
.tgf{background:var(--tgc-aub);color:rgba(250,248,244,0.72);border-top:1px solid rgba(232,217,184,0.1);}
.tgf-inner{max-width:1240px;margin:0 auto;padding:64px clamp(18px,4vw,40px) 40px;}
.tgf-wordmark{height:26px;width:auto;display:block;margin-bottom:18px;}
.tgf-tag{font-size:15px;line-height:1.5;color:rgba(250,248,244,0.7);max-width:320px;margin:0 0 20px;}
.tgf-cta{display:inline-block;color:var(--tgc-champL);text-decoration:none;font-size:14px;font-weight:600;}
.tgf-cta:hover{color:var(--tgc-bone);}
.tgf-cols{display:grid;grid-template-columns:repeat(4,1fr);gap:28px;}
.tgf-col h4{color:var(--tgc-bone);font-size:12px;font-weight:600;letter-spacing:.12em;text-transform:uppercase;margin:0 0 14px;}
.tgf-col a{display:block;color:rgba(250,248,244,0.6);text-decoration:none;font-size:14px;padding:6px 0;transition:color .15s ease;}
.tgf-col a:hover{color:var(--tgc-bone);}
.tgf-top{display:grid;grid-template-columns:1.3fr 2fr;gap:48px;}
.tgf-base{display:flex;justify-content:space-between;align-items:flex-start;gap:24px;flex-wrap:wrap;
  margin-top:48px;padding-top:24px;border-top:1px solid rgba(232,217,184,0.1);}
.tgf-base p{margin:0;font-size:12.5px;color:rgba(250,248,244,0.5);}
.tgf-legal{max-width:560px;text-align:right;}
@media(max-width:820px){
  .tgf-top{grid-template-columns:1fr;gap:36px;}
  .tgf-cols{grid-template-columns:repeat(2,1fr);}
  .tgf-base{flex-direction:column;}
  .tgf-legal{text-align:left;}
}



/* uniform section gap on every page (fixed px, no vh/rem drift) */
.section,.surface-day,.surface-night,
.proof,.pillars-inner,.hiw-inner,.whofor-inner,.apex-inner,.closer-inner{
  padding-top:80px!important;padding-bottom:80px!important}
@media(max-width:768px){
.section,.surface-day,.surface-night,
.proof,.pillars-inner,.hiw-inner,.whofor-inner,.apex-inner,.closer-inner{
  padding-top:52px!important;padding-bottom:52px!important}}


/* ---------- contact form refinements (23 Aug) ---------- */
.field label .opt{margin-left:6px;font-family:var(--font-mono);font-size:10px;font-weight:400;letter-spacing:0.06em;text-transform:uppercase;color:rgba(21,16,42,0.38)}
.field select:invalid,.field select option[value=""]{color:rgba(21,16,42,0.45)}
.field textarea{min-height:110px}
.assure{margin:14px 0 0;text-align:center;font-size:12.5px;line-height:1.55;color:rgba(21,16,42,0.55)}
.success .ref{font-family:var(--font-mono);font-size:12px;color:var(--champ);letter-spacing:0.04em}
`;
